import { render, staticRenderFns } from "./CancellationPolicies.vue?vue&type=template&id=a03d9680&scoped=true&"
import script from "./CancellationPolicies.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicies.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicies.vue?vue&type=style&index=0&id=a03d9680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03d9680",
  null
  
)

export default component.exports